import {
  Button,
  Dialog,
  InputLabel,
  InputContainer,
  InputOption,
  InputSelect,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "@sellar-io/components";
import { useState } from "react";
import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { useSupplierRelationshipUpdate } from "../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipUpdate";

export const EditVatDialog = ({
  active,
  setActive,
  connection,
}: {
  active: boolean;
  setActive: (active: boolean) => void;
  connection?: SupplierRelationshipGetResponseType;
}) => {
  const [VAT, setVAT] = useState<number | undefined>(
    connection?.vatPercentage ?? undefined,
  );
  const [previousConnection, setPreviousConnection] = useState(connection);
  if (connection !== previousConnection) {
    setPreviousConnection(connection);
    setVAT(connection?.vatPercentage ?? undefined);
  }

  const updateConnectionMutation = useSupplierRelationshipUpdate(
    connection?.id ? connection.id : 0,
  );

  const loading = updateConnectionMutation.isPending;

  return (
    <Dialog active={active} onDismiss={() => setActive(false)}>
      <DialogNavigation
        leftIcon="CHEVRON_DOWN"
        onClickLeftIcon={() => setActive(false)}
        title="Edit VAT"
      />
      <form
        onSubmit={(e) => {
          e.preventDefault();

          updateConnectionMutation.mutate(
            {
              vatPercentage: VAT,
            },
            {
              onSuccess: () => {
                setActive(false);
              },
            },
          );
        }}
        className="flex flex-col gap-2"
      >
        <DialogContent className="flex flex-col gap-4">
          <InputLabel>Vat Percentage</InputLabel>
          <InputContainer>
            <InputSelect
              value={VAT}
              onChange={(e) => setVAT(Number(e.target.value))}
            >
              <InputOption value={20}>20%</InputOption>
              <InputOption value={0}>No VAT</InputOption>
            </InputSelect>
          </InputContainer>
        </DialogContent>
        <DialogCTA>
          <Button type="submit" loading={loading}>
            Confirm
          </Button>
        </DialogCTA>
      </form>
    </Dialog>
  );
};
